const LOGIN = 'LOGIN'
const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
const LOGIN_ERROR = 'LOGIN_ERROR'
const LOGOUT = 'LOGOUT'
const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
const CHANGE_PASSWORD_ERROR = 'CHANGE_PASSWORD_ERROR'

export default {
  namespaced: true,
  state: {
    user: localStorage.getItem('user'),
    authenticated: !!localStorage.getItem('token'),
    token: localStorage.getItem('token')
  },
  mutations: {
    [LOGIN] (state) {
      state.do_login = true
    },
    [LOGIN_SUCCESS] (state) {
      state.authenticated = true
      state.do_login = false
    },
    [LOGIN_ERROR] (state) {
      state.do_login = false
    },
    [LOGOUT] (state) {
      state.authenticated = false
    },
    [CHANGE_PASSWORD] (state) {
      state.do_change_password = true
    },
    [CHANGE_PASSWORD_SUCCESS] (state) {
      state.do_change_password = false
    },
    [CHANGE_PASSWORD_ERROR] (state) {
      state.do_change_password = false
    }
  },
  actions: {
    login ({ commit, state, getters, rootState }, creds) {
      return this.dispatch('request', { method: 'post', url: 'get-token', data: creds })
        .then(
          response => {
            localStorage.setItem('user', creds.username)
            state.user = creds.username
            localStorage.setItem('token', response.data.token)
            state.token = response.data.token
            commit(LOGIN_SUCCESS)
            return response
          }
        ).catch(error => {
          commit(LOGIN_ERROR)
          throw error
        })
    },
    logout ({ commit, state }) {
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      localStorage.removeItem('group')
      state.userData = {}
      commit(LOGOUT)
    },
    changePassword ({ commit, state, getters, rootState }, oldNew1New2Passwd) {
      commit(CHANGE_PASSWORD)
      return this.dispatch('request', { method: 'post', url: `api/user/${state.userData.user.id}/change_password`, data: oldNew1New2Passwd })
        .then(
          response => {
            rootState.notification = {
              group: 'global',
              duration: 4000,
              type: 'success',
              title: 'Change password',
              text: 'Sucessfully saved new password'
            }
            commit(CHANGE_PASSWORD_SUCCESS)
            return response
          }
        ).catch(error => {
          // commit(CHANGE_PASSWORD_ERROR)
          throw error
        })
    },
    /* user ({ commit, state }) {
      if (state.authenticated) {
        return this.dispatch('request', { method: 'get', url: 'api/user/auth' })
          .then(
            response => {
              response.data.clients = response.data.clients.map(x => x.id)
              state.userData = response.data
              if (!localStorage.getItem('company')) {
                if (state.userData.user) {
                  state.company = state.userData.user.groups[0].id
                  localStorage.setItem('company', state.company)
                }
              }
              return response.data
            }
          ).catch(error => {
            throw error
          })
      }
    }, */
    hasPermision ({ commit, getters, state }, actionRequired) {
      var prohibitions = new Map(getters.permisionCollection.map(x => [x.id, x.prohibitions]))
      var hasPermision = true
      if (state.userData.roles) {
        state.userData.roles.forEach(rol => {
          if (prohibitions.get(rol.id).indexOf(actionRequired) >= 0) hasPermision = false
        })
      } else {
        hasPermision = false
      }
      return hasPermision
    }
  },
  getters: {
    permisionCollection (state) { return [state.admin, state.office, state.warehouseResp, state.kiosk, state.client, state.forklift] }
  }
}



// WEBPACK FOOTER //
// ./src/store/auth.js